// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"bs-lp20-src-components-image-carousel-module-carousel-wrapper","pagingButton":"bs-lp20-src-components-image-carousel-module-paging-button"};